import { render, staticRenderFns } from "./MainJou.vue?vue&type=template&id=0a16069e&scoped=true&"
import script from "./MainJou.vue?vue&type=script&lang=js&"
export * from "./MainJou.vue?vue&type=script&lang=js&"
import style0 from "./MainJou.vue?vue&type=style&index=0&id=0a16069e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16069e",
  null
  
)

export default component.exports